import React, { useEffect, useState } from "react";
import { FiX } from "react-icons/fi";
import { IoMenu } from "react-icons/io5";
import { MdOutlineKeyboardArrowDown } from "react-icons/md";
import { NavLink, useLocation } from "react-router-dom";
import rdaLogo from "../../asset/rda-web-logo 1.png";

const MobileNavbar = ({ navTab }) => {
  const [isOpen, setIsOpen] = useState(false);
  const toggleSidebar = () => setIsOpen(!isOpen);
  const [openIndex, setOpenIndex] = useState(null);
  const [activeParentIndex, setActiveParentIndex] = useState(null);
  const location = useLocation();

  useEffect(() => {
    setOpenIndex(null);
    setActiveParentIndex(null);
  }, [location.pathname]);

  useEffect(() => {
    navTab.forEach((nav, i) => {
      const isParentActive =
        nav.option && nav.paths?.includes(location.pathname);
      if (isParentActive) {
        setActiveParentIndex(i);
      }
    });
  }, [location.pathname, navTab]);

  useEffect(() => {
    const handler = (event) => {
      if (!event.target.closest(".sidebar") && isOpen) setIsOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [isOpen]);
  return (
    <>
      <div
        onClick={toggleSidebar}
        className="p-1.5 bg-[#00643b] rounded-md text-white cursor-pointer"
      >
        <IoMenu />
      </div>
      <div
        className={`${
          isOpen ? "fixed inset-0 z-50 bg-black bg-opacity-70" : ""
        }`}
        onClick={() => setIsOpen(false)}
      >
        <div
          className={`fixed z-10 top-0 right-0 h-full lg:w-[30%] md:w-[39%] w-[75%] overflow-y-auto scrollbar-hide bg-white text-[#555555] transform ${
            isOpen ? "translate-x-0" : "-translate-x-full hidden"
          } transition-transform duration-600 ease-in-out sidebar`}
          onClick={(e) => e.stopPropagation()}
        >
          <div className=" p-2 overflow-y-auto custom-scroll">
            <div className="flex flex-col gap-3 w-full h-max">
              <div className="flex justify-between items-center  ">
                <img src={rdaLogo} className=" w-10 " alt="" />

                <span
                  onClick={toggleSidebar}
                  className="p-1 bg-[#00643b] rounded-md text-white w-max cursor-pointer"
                >
                  <FiX className="size-[20px]" />
                </span>
              </div>
              <div className="w-full flex flex-col items-start gap-5 pl-3   sm:text-[1.5rem] text-[1.2rem] font-medium">
                {navTab.map((nav, i) =>
                  nav.option ? (
                    <div
                      className="w-full relative dropdown-container "
                      key={i}
                    >
                      <NavLink
                        to={`${nav.link}`}
                        onClick={() => setIsOpen(false)}
                        className={`flex items-center justify-between w-full cursor-pointer sm:hover:text-[#00643B] ${
                          activeParentIndex === i
                            ? "text-[#00643B] "
                            : "text-[#9A9A9A]"
                        }`}
                      >
                        {nav.name}{" "}
                        <MdOutlineKeyboardArrowDown
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            setOpenIndex(openIndex === i ? null : i);
                          }}
                          className=" cursor-pointer"
                        />
                      </NavLink>
                      {openIndex === i && (
                        <div
                          className={`overflow-hidden transition-all duration-500 `}
                        >
                          <div className=" flex flex-col items-start text-[1rem] gap-1.5 p-2">
                            {nav?.options?.map((opt, oi) => (
                              <NavLink
                                key={oi}
                                to={`${opt.optionLink}`}
                                onClick={() => setIsOpen(false)}
                                className={`px-2 py-1 ${
                                  location.pathname === opt.optionLink
                                    ? "text-[#00643B]"
                                    : "text-[#9A9A9A]"
                                }  hover:text-[#00643B]`}
                              >
                                {opt.optionName}
                              </NavLink>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>
                  ) : (
                    <NavLink
                      to={`${nav.link}`}
                      key={i}
                      onClick={() => setIsOpen(false)}
                      className={`${
                        location.pathname === nav.link
                          ? "text-[#00643B]"
                          : "text-[#9A9A9A]"
                      }   cursor-pointer hover:text-[#00643B]`}
                    >
                      {nav.name}
                    </NavLink>
                  )
                )}
              </div>
              <div className="flex  items-start flex-col gap-5 pl-3">
                <button className="p-2  text-[1rem] rounded-xl  bg-transparent border border-[#00643B] font-semibold text-[#00643B]">
                  Lodge a Complaint
                </button>
                    <a
  href="https://digital-rda.gop.pk/auth/signin"
  target="_blank"
  rel="noopener noreferrer"
  className="xl:px-3 px-2 xl:py-2 py-1.5 xl:text-[1rem] lg:text-[.85rem] text-[.8rem] xl:rounded-xl rounded-lg bg-[#00643B] border border-[#00643B] font-semibold text-white hover:text-[#00643B] hover:bg-white"
>
  Digital RDA
</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MobileNavbar;
